export default {
  title: 'Completed actions',
  tooltip: 'Click here to see the projects we have completed so far',
  noResults: 'No results',
};
